import './index.scss'
$("#nav5").addClass("active");
$(".out").click(function() {
    let video = $(".active video")[0];
    video.pause();
    $(".video-pop").hide();

})
$(".content ul li").click(function() {
    $(".video-pop").css('display','flex');
    let index = $(this).index();
    $(".video-pop .content").eq(index).addClass("active").siblings().removeClass("active");
})